import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const DownLeft: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m469.71 590-269.71-.31v-269.54h30v239.57l239.74.28z' />
    <path d='m205.52 372.57h380v30h-380z' transform='matrix(.70574793 -.70846302 .70846302 .70574793 -158.2 394.21)' />
    <path d='m589.73 214.08-63.64 63.64-21.21-21.21 42.43-42.43c11.72-11.72 30.71-11.72 42.43 0z' />
  </IconBase>
));

DownLeft.displayName = 'DownLeft';

export default DownLeft;
